import { Skeleton } from '@chakra-ui/react';
import { RouterProvider } from 'react-router-dom';

import { router } from './router';

export default function AppRouter() {
  return <RouterProvider router={router} fallbackElement={<Skeleton animation='wave' />} />;
}
